import React from 'react'
import type { GridProps } from '@vtex/admin-ui'
import { Grid, Text, csx } from '@vtex/admin-ui'
import { FormattedMessage, FormattedNumber } from 'react-intl'

import { useOrderForm } from '../../../../../../core/requests/checkout'
import {
  getCurrencyCode,
  getDeliveryValue,
  getOrderTotal,
  getItemsTotal,
} from '../../../../../../core/utils/orderForm'

export type TotalOrderSectionProps = GridProps

export const TotalOrderSection = ({ ...props }: TotalOrderSectionProps) => {
  const { orderForm } = useOrderForm()
  const currencyCode = getCurrencyCode(orderForm)
  const deliveryValue = getDeliveryValue(orderForm)
  const subTotal = getItemsTotal(orderForm)
  const total = getOrderTotal(orderForm)

  return (
    <Grid rowGap="1rem" className={csx({ marginTop: '$space-6' })} {...props}>
      <div
        className={csx({ justifyContent: 'space-between', display: 'flex' })}
      >
        <Text variant="action1" tone="secondary">
          <FormattedMessage id="checkout.order-summary.label.subtotal" />
        </Text>
        <Text variant="action1" tone="secondary">
          <FormattedNumber
            currency={currencyCode}
            value={subTotal}
            style="currency"
          />
        </Text>
      </div>
      <div
        className={csx({ justifyContent: 'space-between', display: 'flex' })}
      >
        <Text variant="action1" tone="secondary">
          <FormattedMessage id="checkout.order-summary.label.delivery" />
        </Text>
        <Text variant="action1" tone="secondary">
          {deliveryValue === 0 ? (
            <FormattedMessage id="checkout.order-summary.label.value-delivery" />
          ) : (
            <FormattedNumber
              currency={currencyCode}
              value={deliveryValue}
              style="currency"
            />
          )}
        </Text>
      </div>
      <div
        className={csx({ justifyContent: 'space-between', display: 'flex' })}
      >
        <Text variant="title1" tone="primary">
          <FormattedMessage id="checkout.order-summary.label.total" />
        </Text>
        <Text variant="display" tone="primary">
          <FormattedNumber
            currency={currencyCode}
            value={total}
            style="currency"
          />
        </Text>
      </div>
    </Grid>
  )
}
